export abstract class LoginRoutesConstants {
  static readonly SIGNUP = "signup";
  static readonly LOGIN = "login";
  static readonly RESET_PASSWORD = "reset-password";
  static readonly VERIFY_EMAIL = "verify-email";
  static readonly REGISTER = "register";
  static readonly ERROR = "login-error";
  static readonly AUTH_CALLBACK = "auth/callback";
  static readonly TERMS = "terms";
  static readonly PRIVACY_POLICY = "privacy-policy";

  static readonly main = (): string => `/${this.LOGIN}`;
  static readonly signup = (): string => `/${this.SIGNUP}`;
  static readonly login = (): string => `/${this.LOGIN}`;
  static readonly resetPassword = (): string => `/${this.RESET_PASSWORD}`;
  static readonly verifyEmail = (): string => `/${this.VERIFY_EMAIL}`;
  static readonly register = (): string => `/${this.REGISTER}`;
  static readonly error = (): string => `/${this.ERROR}`;
  static readonly terms = (): string => `/${this.TERMS}`;
  static readonly privacyPolicy = (): string => `/${this.PRIVACY_POLICY}`;
}
